// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: in the Assistant chat Konvo's words are plain text with no bubble, avatar, name or time
// (design/assistant-chat-unify); its mark beside the first line says who is talking. Only in the
// chat itself: Home's pop-up and other DMs keep their bubbles.

import {AssistantChatScopeContext} from '@app/features/konvo_assistant/components/chat_chrome/AssistantChatChromeContext';
import styles from '@app/features/konvo_assistant/components/chat_stream/AssistantChatStream.module.css';
import {KonvoLogo} from '@app/features/ui/components/icons/KonvoLogo';
import {KONVOBOT_ID} from '@konvo/constants/src/AppConstants';
import {useContext} from 'react';

export function AssistantReplyMark({channelId, authorId}: {channelId: string; authorId: string}) {
	const scope = useContext(AssistantChatScopeContext);
	if (scope !== channelId || authorId !== KONVOBOT_ID) return null;
	return (
		<span className={styles.replyMark} aria-hidden="true" data-flx="konvo-assistant.reply-mark">
			<KonvoLogo size={20} />
		</span>
	);
}
